import { COUNTRY_LIST } from '../../../../../../../../../constants/COUNTRIES';

const CountryBranchTitle = ({ branch }) => branch.condition.reduce((acc, country) => `${acc}${COUNTRY_LIST?.find(countryElem => countryElem.id === country)?.label ?? country}, `, '').slice(0, -2) ?? '';

export default CountryBranchTitle;